import { Button } from 'ui/mobile-ds';
import { Layout } from '../Layout';
import AppConfig from '@/AppConfig';
import { useLocation, useRouteError } from 'react-router-dom';
import { useEffect } from 'react';
import { logger } from '@/utils/logger';
import { decodeAuthToken } from '@/utils';
import { useAppContext } from '@/context/AppContext';
import ErrorCat from '@/assets/error-cat.svg';

interface IProps {
  layoutProps?: React.ComponentProps<typeof Layout.Main>;
  heading?: string;
  description?: string | null;
  actions?: React.ReactNode[];
}

const ErrorScreen = (props: IProps) => {
  const {
    layoutProps,
    heading = 'Something went wrong :(',
    description = 'We are sorry, but something went wrong. Please try again later.',
    actions = [
      <Button
        intent="secondary"
        className="border-primary-500 border"
        onClick={() => {
          if (isWebView) {
            window?.NativeBridge?.onNativeClose?.();
          } else {
            window.location.href = AppConfig.HOME_PAGE;
          }
        }}
      >
        Go home
      </Button>,
      <Button
        intent="secondary"
        onClick={() => window.location.reload()}
        className="border-primary-500 border"
      >
        Refresh
      </Button>,
    ],
  } = props;

  const routeError = useRouteError();
  const { pathname } = useLocation();

  useEffect(() => {
    const user = decodeAuthToken();
    logger.updateConfig({
      identifier: user?.memberId,
    });
    window.dev.e('routeError', routeError);
    logger.error(
      // @ts-ignore
      routeError?.response?.data?.error?.message ??
        // @ts-ignore
        routeError?.message ??
        'Uncaught Exception',
      {
        type: 'UncaughtException',
        url: window.location.href,
        memberId: user?.memberId,
        organisationId: user?.organisationId,
        urlPath: pathname,
        error: routeError,
      }
    );
  }, [routeError, pathname]);

  const { isWebView } = useAppContext();

  return (
    <Layout.Main
      containerProps={{
        className: 'h-full',
      }}
      {...layoutProps}
    >
      <div className="flex flex-col items-center justify-center h-full gap-8 max-w-[440px] mx-auto">
        <div className="text-center">
          <img src={ErrorCat} className="mx-auto w-[120px]" />
          <h1 className="text-2xl font-bold text-gray-700 font-chromatica">
            {heading}
          </h1>
          {description ? (
            <p className="text-sm text-gray-500 mt-2">{description}</p>
          ) : null}
        </div>
        {actions?.length > 0 ? (
          <div className="flex gap-4">{actions}</div>
        ) : null}
      </div>
    </Layout.Main>
  );
};

export default ErrorScreen;
